import {
  Auth_User_Entity_Order_By,
  GetAdminUtilizzoReferralSubscription,
  GetAmiciPresentatiQuery,
  GetPrivacyQuery,
  GetProfileQuery,
  Order_By,
  SearchSottoscrizioniAmicoSubscription,
  SearchSottoscrizioniSegnalatoreSubscription,
  Sottoscrizione_Order_By,
  _Tipologia_Profilo_Enum,
} from '../../../_core/_graphql/generated';
import { DeepPartial } from '@apollo/client/utilities';
import { DecodedToken } from '../../../_core/_services/auth.service';

export type UserState = {
  codice_operatore_loading?: boolean;
  codice_operatore?: string;
  user_data?: DecodedToken;
  user_loading: boolean;
  privacy_data?: DeepPartial<GetPrivacyQuery['admin_consenso_privacy']>;
  privacy_loading: boolean;
  type: _Tipologia_Profilo_Enum;
  failure?: any;

  prosumer_profile_data?: DeepPartial<GetProfileQuery['profilo'][0]> | 'NO';
  prosumer_profile_loading: boolean;
  installatore_profile_data?: DeepPartial<GetProfileQuery['profilo'][0]> | 'NO';
  installatore_profile_loading: boolean;
  founder_profile_data?: DeepPartial<GetProfileQuery['profilo'][0]> | 'NO';
  founder_profile_loading: boolean;

  rete_sottoscrizioni_lista_data?: DeepPartial<
    SearchSottoscrizioniSegnalatoreSubscription['search_sottoscrizioni']
  >;
  rete_sottoscrizioni_lista_loading?: boolean;
  rete_sottoscrizioni_lista_page: number;
  rete_sottoscrizioni_lista_page_size: number;
  rete_sottoscrizioni_lista_total: number;
  rete_sottoscrizioni_lista_search: string;

  rete_sottoscrizioni_aggregato_data?: Record<
    string,
    { cer: any; count: number }
  >;
  rete_sottoscrizioni_aggregato_loading?: boolean;
  rete_sottoscrizioni_aggregato_page: number;
  rete_sottoscrizioni_aggregato_page_size: number;
  rete_sottoscrizioni_aggregato_search: string;
  rete_sottoscrizioni_aggregato_active_filter?: any;

  rete_sottoscrizioni_lista_active_filter?: any;
  rete_sottoscrizioni_lista_order_by: Sottoscrizione_Order_By[];

  rete_sottoscrizioni_configurazioni?: Array<{
    id: string;
    alias: string;
    cer_padre_alias: string | null;
  }>;

  rete_amici_presentati_lista_data?: DeepPartial<
    GetAmiciPresentatiQuery['search_user_entity']
  >;
  rete_amici_presentati_lista_loading?: boolean;
  rete_amici_presentati_lista_page: number;
  rete_amici_presentati_lista_page_size: number;
  rete_amici_presentati_lista_total: number;
  rete_amici_presentati_lista_search: string;
  rete_amici_presentati_lista_order_by: Auth_User_Entity_Order_By[];

  rete_amici_presentati_aggregato_data?: number;
  rete_amici_presentati_aggregato_loading?: boolean;
};

export const initialUserState: UserState = {
  codice_operatore_loading: true,
  codice_operatore: undefined,
  user_loading: true,
  user_data: undefined,
  privacy_loading: true,
  privacy_data: undefined,
  type: _Tipologia_Profilo_Enum.Prosumer,

  prosumer_profile_data: undefined,
  prosumer_profile_loading: true,

  installatore_profile_data: undefined,
  installatore_profile_loading: true,

  founder_profile_data: undefined,
  founder_profile_loading: true,

  rete_sottoscrizioni_lista_data: undefined,
  rete_sottoscrizioni_lista_loading: true,
  rete_sottoscrizioni_lista_page: 0,
  rete_sottoscrizioni_lista_page_size: 10,
  rete_sottoscrizioni_lista_total: 0,
  rete_sottoscrizioni_lista_search: '',

  rete_sottoscrizioni_aggregato_data: undefined,
  rete_sottoscrizioni_aggregato_loading: true,
  rete_sottoscrizioni_aggregato_page: 0,
  rete_sottoscrizioni_aggregato_page_size: 10,
  rete_sottoscrizioni_aggregato_search: '',
  rete_sottoscrizioni_aggregato_active_filter: undefined,

  rete_sottoscrizioni_lista_active_filter: undefined,
  rete_sottoscrizioni_lista_order_by: [{ updated_at: Order_By.Desc }],

  rete_sottoscrizioni_configurazioni: undefined,

  rete_amici_presentati_lista_data: undefined,
  rete_amici_presentati_lista_loading: true,
  rete_amici_presentati_lista_page: 0,
  rete_amici_presentati_lista_page_size: 10,
  rete_amici_presentati_lista_total: 0,
  rete_amici_presentati_lista_search: '',
  rete_amici_presentati_lista_order_by: [{ created_timestamp: Order_By.Desc }],

  rete_amici_presentati_aggregato_data: undefined,
  rete_amici_presentati_aggregato_loading: true,

  failure: undefined,
};
